import { render, staticRenderFns } from "./SubPPbom.vue?vue&type=template&id=88e0c798&scoped=true&"
import script from "./SubPPbom.vue?vue&type=script&lang=js&"
export * from "./SubPPbom.vue?vue&type=script&lang=js&"
import style0 from "./SubPPbom.vue?vue&type=style&index=0&id=88e0c798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e0c798",
  null
  
)

export default component.exports